import Phaser from 'phaser';

export default class menuScene extends Phaser.Scene {
  constructor() {
    super('menuScene');
    this.textStyle = {
      font: '32px Arial',
      fill: '#ffffff',
      align: 'center',
    };
  }
  preload() {
    this.menuControls = this.input.keyboard.addKeys({
      space: Phaser.Input.Keyboard.KeyCodes.SPACE,
      esc: Phaser.Input.Keyboard.KeyCodes.ESC,
    });
  }
  init(data) {
    this.cameras.main.setBackgroundColor('#000000');
  }

  create() {
    this.sys.game.GAMESTATES = {
      START: 0,
      PAUSE: 1,
      GAMEOVER: 2,
      RUNNING: 3,
    };
    this.sys.game.gameState = this.sys.game.GAMESTATES.START;
    this.sys.game.menuTexts = {
      0: 'New Game\nPress the SpaceBar to Start',
      1: 'Game Paused\nPress the SpaceBar to Resume',
      2: 'Game Over\nPress the SpaceBar to Restart',
    };

    this.sys.game.menuText = this.add.text(
      this.game.config.width / 2,
      this.game.config.height / 2,
      this.sys.game.menuTexts[this.sys.game.gameState],
      this.textStyle
    );
    this.sys.game.menuText.setOrigin(0.5);
  }
  update() {
    if (
      Phaser.Input.Keyboard.JustDown(this.menuControls.space) &&
      this.sys.game.gameState !== this.sys.game.GAMESTATES.RUNNING
    ) {
      switch (this.sys.game.gameState) {
        case this.sys.game.GAMESTATES.START:
          this.scene.launch('game-Scene');
          break;
        case this.sys.game.GAMESTATES.PAUSE:
          this.scene.resume('game-Scene');
          break;
        case this.sys.game.GAMESTATES.GAMEOVER:
          this.scene.restart('game-Scene');
          this.scene.sendToBack('menuScene');
          break;
      }
      this.sys.game.gameState = this.sys.game.GAMESTATES.RUNNING;
    } else if (
      Phaser.Input.Keyboard.JustDown(this.menuControls.esc) &&
      this.sys.game.gameState === this.sys.game.GAMESTATES.RUNNING
    ) {
      this.scene.pause('game-Scene');
      this.sys.game.gameState = this.sys.game.GAMESTATES.PAUSE;
    }
  }
}
